import { render, staticRenderFns } from "./FootprintDetail.vue?vue&type=template&id=a94a4934&scoped=true&"
import script from "./FootprintDetail.vue?vue&type=script&lang=js&"
export * from "./FootprintDetail.vue?vue&type=script&lang=js&"
import style0 from "./FootprintDetail.vue?vue&type=style&index=0&id=a94a4934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94a4934",
  null
  
)

export default component.exports